export const TAG = {
  ORANGE: 0,
  PINK: 1,
  RED: 2,
  YELLOW: 3,
}
